import { type AuthInfo } from '@/session.ts';

export type FFOptions = {
  name: string;
  defaultEnabled?: boolean | ((authInfo?: AuthInfo | null) => boolean);
  defaultValue?: string;
};

export const flags = {
  terminal: {
    name: 'terminal',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  tournaments: {
    name: 'tournaments',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  vox: {
    name: 'vox-lab',
    defaultEnabled: true,
  },
  twitterGraph: {
    name: 'twitter-graph',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  twttrApi: {
    name: 'twttr-api',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  hyperliquidIntegration: {
    name: 'terminal-hyperliquid',
    defaultEnabled: false,
  },
  hyperliquidBuilderFees: {
    name: 'terminal-hyperliquid-builder-fees',
    defaultEnabled: true,
    defaultValue: JSON.stringify({
      enabled: true,
      spotMarketFeeTenthsBp: 0,
      perpMarketFeeTenthsBp: 0,
      approvalMaxFeeRate: '1%',
    }),
  },
  toolsCharts: {
    name: 'tools-charts',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  streamStats: {
    name: 'stream-stats',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  terminalPolymarket: {
    name: 'terminal-polymarket',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  terminalCrypto: {
    name: 'terminal-crypto',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  terminalKalshi: {
    name: 'terminal-kalshi',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  terminalHyperliquidOutcomes: {
    name: 'terminal-hyperliquid-outcomes',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
  terminalLeaderboard: {
    name: 'terminal-leaderboard',
    defaultEnabled: false,
  },
  terminalLeaderboardManageAction: {
    name: 'terminal-leaderboard-manage-action',
    defaultEnabled: false,
  },
  newsDeck: {
    name: 'news-deck',
    defaultEnabled: true,
  },
  streamTimeSeries: {
    name: 'stream-time-series',
    defaultEnabled: (authInfo) => Boolean(authInfo?.isAdmin),
  },
} satisfies Record<string, FFOptions>;
